import { useEffect, useState } from "react";
import LoadingAndEmptyStateWrapper from "../../../../patient/patient-list/patient-chart-new/patient-side-bar-components/encounterSummaryComponents/commonWrappers/LoadingAndEmptyStateWrapper.tsx";

// const DEFAULT_ERR_TOAST: Toast = {
//   type: "error",
//   message: "Something went wrong",
// };

export const FallBackComp = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);

    return () => setIsLoading(false);
  }, []);

  return (
    <LoadingAndEmptyStateWrapper
      loading={isLoading}
      isEmpty={false}
      emptyMessage="No data available"
    />
  );
};
